import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import React from "react";
import ExportButton from "../../../commons/export/ExportButton";
import { tableStyles } from "../../../commons/table/tableConfig";

const SiniestrosTable = ({ data, loading }) => {
  const columns = [
    {
      header: "Período",
      accessorKey: "periodo",
      enableColumnActions: false,
      align: "center",
    },
    {
      header: "Apellido y Nombre",
      accessorKey: "nombreCompletoTrabajador",
      enableColumnActions: false,
      align: "center",
    },
    {
      header: "DNI",
      accessorKey: "numeroDocumento",
      enableColumnActions: false,
      align: "center",
      Cell: ({ renderedCellValue }) => (
        // que el numero de documento tenga formato de miles
        Intl.NumberFormat("es-AR").format(renderedCellValue)
      ),
    },
    {
      header: "Agente de Riesgo",
      accessorKey: "riesgos",
      enableColumnActions: false,
      width: "30%",
      align: "center",
      // por especificacion del analista, como el campo de riesgos
      // es muy largo, se habló sobre splitear el campo sobre el
      // pipe "|" que trae el back. Entonces, usamos ese caracter
      // "|" para separarlo esteticamente en una lista itemizada.
      Cell: ({ renderedCellValue }) => (
        <ul style={{ paddingLeft: 20 }}>

          {renderedCellValue?.split("|").map((r) => (
            <li key={r.slice(0, 10)}>{r}</li>
          ))}
        </ul>
      )
    },
    {
      header: "CIE-10",
      accessorKey: "diagnostico",
      enableColumnActions: false,
      width: "30%",
      align: "center",
    },
    {
      header: "Siniestro",
      accessorKey: "numeroSiniestroART",
      enableColumnActions: false,
      align: "center",
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      layoutMode="grid"
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      initialState={{ showColumnFilters: true }}
      style={{ ...tableStyles.container }}
      renderToolbarInternalActions={() => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <ExportButton
            data={data}
            columns={columns}
            disabled={data.length === 0}
            title="Siniestros por Exámenes Periódicos"
          />
        </div>
      )}
    />
  );
};

export default SiniestrosTable;
